import React from 'react';

const Hero = () => {
    return (
        <section className="relative pt-24 md:pt-40 pb-8 overflow-hidden">
            {/* Background Decor (Ultra-Intensity Neon Lights) */}
            <div className="absolute top-0 left-0 w-full h-full -z-10 bg-slate-50/10 overflow-hidden">
                <div className="absolute top-[-25%] left-[-15%] w-[70%] h-[70%] bg-indigo-600/30 rounded-full blur-[120px] animate-pulse-slow"></div>
                <div className="absolute bottom-[0%] right-[-15%] w-[60%] h-[60%] bg-sky-500/30 rounded-full blur-[100px] animate-pulse-slow lg:delay-1000"></div>

                {/* Vivid Neon Accents */}
                <div className="absolute top-[10%] right-[0%] w-[40%] h-[40%] bg-fuchsia-500/25 rounded-full blur-[130px] animate-float"></div>
                <div className="absolute bottom-[-20%] left-[5%] w-[45%] h-[45%] bg-indigo-700/25 rounded-full blur-[140px] animate-pulse-slow delay-700"></div>

                {/* Vibrant Neon Beams - Higher Opacity for impact */}
                <div className="absolute top-1/4 left-0 w-full h-[3px] bg-indigo-500/40 rotate-[-12deg] blur-[4px]"></div>
                <div className="absolute bottom-1/3 left-0 w-full h-[3px] bg-sky-400/40 rotate-[8deg] blur-[3px]"></div>

                {/* Secondary Beams */}
                <div className="absolute top-1/2 left-0 w-full h-[2px] bg-fuchsia-400/30 rotate-[-5deg] blur-[2px]"></div>

                {/* Bottom Convergence Mask - Blends into white background */}
                <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-white via-white/50 to-transparent"></div>
            </div>

            <div className="section-padding text-center">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50/50 border border-indigo-100 text-indigo-600 text-sm font-medium mb-8 animate-fade-in">
                    <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-gradient-to-r from-indigo-600 to-sky-500"></span>
                    </span>
                    <span className="gradient-text font-bold">Modern ERP</span> Infrastructure for Manufacturers
                </div>

                <h1 className="heading-xl mb-8">
                    Enterprise Traceability with <span className="gradient-text">Unmatched Detail</span>
                </h1>

                <p className="text-p max-w-2xl mx-auto mb-10">
                    Capture every movement, verify every batch, and ensure compliance with the real-time traceability engine built for high-stakes manufacturing.
                </p>

                <div className="flex flex-wrap justify-center gap-4 mb-12">
                    <button
                        className="btn-primary text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4"
                        onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                    >
                        Get Started Free
                    </button>
                    <button className="btn-secondary text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4">Request a Sandbox</button>
                </div>
            </div>
        </section>
    );
};

export default Hero;
